import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-item-log-page-ui',
    templateUrl: './bb-item-log-page-ui.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class BbItemLogPageUiComponent {
  constructor() {}
}
